<template>
  <div ref="chartRef" class="w-full h-96"></div>
</template>

<script setup>
import { ref, watch, onMounted, onBeforeUnmount } from "vue";
import * as echarts from "echarts";

const props = defineProps({
  months: {
    type: Array,
    required: true
  },
  seriesData: {
    type: Array,
    required: true,
    // Ожидается формат:
    // [
    //   { name: "Продажи", data: [120, 200, ...] },
    //   { name: "Прибыль", data: [60, 120, ...] },
    //   { name: "Затраты", data: [100, 180, ...] }
    // ]
  }
});

const chartRef = ref(null);
let chartInstance = null;

onMounted(() => {
  chartInstance = echarts.init(chartRef.value);
  updateChart();
  window.addEventListener("resize", handleResize);
});

onBeforeUnmount(() => {
  if (chartInstance) chartInstance.dispose();
  window.removeEventListener("resize", handleResize);
});

// Следим за изменениями данных и обновляем график
watch(
  () => [props.months, props.seriesData],
  () => updateChart(),
  { deep: true }
);

function updateChart() {
  if (!chartInstance) return;

  const options = {
    tooltip: { trigger: "axis" },
    legend: {
      data: props.seriesData.map(s => s.name),
      top: 0
    },
    grid: {
      left: "3%",
      right: "3%",
      bottom: "3%",
      containLabel: true
    },
    xAxis: {
      type: "category",
      data: props.months,
      axisTick: { show: false }
    },
    yAxis: {
      type: "value",
      splitLine: { lineStyle: { type: "dashed" } }
    },
    series: props.seriesData.map(s => ({
      name: s.name,
      type: "line",
      smooth: true,
      symbol: "circle",
      symbolSize: 8,
      data: s.data
    }))
  };

  chartInstance.setOption(options);
}

function handleResize() {
  if (chartInstance) chartInstance.resize();
}
</script>

<style scoped>
.w-full {
  width: 100%;
}
.h-96 {
  height: 24rem;
}
</style>
